import {
  Box,
  Button,
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  Divider,
} from "@mui/material";
import { FC, MouseEvent, useCallback, useState } from "react";

import { Calendar, dateFnsLocalizer, type Event } from "react-big-calendar";

import format from "date-fns/format";
import getDay from "date-fns/getDay";
import enUS from "date-fns/locale/en-US";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";

import "react-big-calendar/lib/css/react-big-calendar.css";

import { Add, Download, Print, Search } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import AddDatePickerEventModal from "./AddDatePickerEventModal";
import AddEventModal from "./AddEventModal";
import { AddTodoModal } from "./AddTodoModal";
import EventInfo from "./EventInfo";
import EventInfoModal from "./EventInfoModal";
import FindDay from "./FindDay";

const locales = {
  "en-US": enUS,
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

export interface ITodo {
  _id: string;
  title: string;
  color?: string;
}

export interface IEventInfo extends Event {
  _id: string;
  receipts_number: number;
  day: Date;
  id: number;
  title: string;
  start: Date;
  end: Date;
  percentage: number;
  total_receipt: number;
  paid: number;
  unpaid: number;
  total_amount_given: number;
  total_amount_received: number;
}

export interface EventFormData {
  description: string;
  todoId?: string;
}

export interface DatePickerEventFormData {
  receipts_number: number | null;
  day?: Date;
}

export const generateId = () =>
  (Math.floor(Math.random() * 10000) + 1).toString();

const initialEventFormState: EventFormData = {
  description: "",
  todoId: undefined,
};

const initialDatePickerEventFormData: DatePickerEventFormData = {
  receipts_number: null,
  day: undefined,
};

const EventCalendar: FC<{ events: any[] }> = ({ events }) => {
  const [openSlot, setOpenSlot] = useState(false);
  const [openDatepickerModal, setOpenDatepickerModal] = useState(false);
  const [openFindDay, setOpenFindDay] = useState(false);
  const [openTodoModal, setOpenTodoModal] = useState(false);
  const [currentEvent, setCurrentEvent] = useState<Event | IEventInfo | null>(
    null
  );
  const [eventInfoModal, setEventInfoModal] = useState(false);

  const [todos, setTodos] = useState<ITodo[]>([]);

  const [eventFormData, setEventFormData] = useState<EventFormData>(
    initialEventFormState
  );

  const [datePickerEventFormData, setDatePickerEventFormData] =
    useState<DatePickerEventFormData>(initialDatePickerEventFormData);

  console.log({ datePickerEventFormData });

  const handleSelectSlot = (event: Event) => {
    setOpenSlot(true);
    setCurrentEvent(event);
  };

  const handleSelectEvent = (event: IEventInfo) => {
    setCurrentEvent(event);
    console.log({ event });
    setEventInfoModal(true);
  };

  const handleClose = () => {
    setEventFormData(initialEventFormState);
    setOpenSlot(false);
  };

  const handleDatePickerClose = () => {
    setDatePickerEventFormData(initialDatePickerEventFormData);
    setOpenDatepickerModal(false);
  };

  const onAddEvent = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    const data = {
      ...eventFormData,
      _id: generateId(),
      // day: currentEvent?.day,
    };

    // const newEvents = [...events, data];

    handleClose();
  };

  const navigate = useNavigate();

  const onAddEventFromDatePicker = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    // setEvents(newEvents)
    // setDatePickerEventFormData(initialDatePickerEventFormData)
    console.log(
      "get data and navigate /create with store data in navigate sate"
    );
    // Data: day, total number of receipts want to generate
    navigate("/receipts/create", {
      state: {
        ...datePickerEventFormData,
      },
    });
  };

  const [date, setDate] = useState<Date | null>(new Date());

  const onNavigate = useCallback((newDate: any) => setDate(newDate), [setDate]);

  return (
    <Box
      mt={2}
      mb={2}
      component="main"
      sx={{
        flexGrow: 1,
        px: 0,
        width: "100%",
      }}
    >
      <Box>
        <Card>
          <CardHeader title="Calender" subheader="Manage your receipts easly" />
          {/* <GoogleSheetParser /> */}
          <Divider />
          <CardContent>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <ButtonGroup
                size="large"
                variant="contained"
                aria-label="outlined primary button group"
              >
                <Button
                  onClick={() => setOpenDatepickerModal(true)}
                  size="large"
                  variant="contained"
                  startIcon={<Add />}
                >
                  Open new day
                </Button>
                <Button
                  onClick={() => setOpenFindDay(true)}
                  size="large"
                  variant="contained"
                  startIcon={<Search />}
                >
                  Find day
                </Button>
                <Button size="large" variant="contained" startIcon={<Print />}>
                  Print Reicepts
                </Button>
                <Button
                  size="large"
                  variant="contained"
                  startIcon={<Download />}
                >
                  Export Reicepts
                </Button>
              </ButtonGroup>
            </Box>
            <Divider style={{ margin: 10 }} />
            <AddEventModal
              open={openSlot}
              handleClose={handleClose}
              eventFormData={eventFormData}
              setEventFormData={setEventFormData}
              onAddEvent={onAddEvent}
              todos={todos}
            />
            <AddDatePickerEventModal
              open={openDatepickerModal}
              handleClose={handleDatePickerClose}
              datePickerEventFormData={datePickerEventFormData}
              setDatePickerEventFormData={setDatePickerEventFormData}
              onAddEvent={onAddEventFromDatePicker}
              todos={todos}
            />
            <FindDay
              date={date}
              open={openFindDay}
              handleClose={() => {
                setOpenFindDay(false);
                setDate(new Date());
              }}
              onSetDate={(date) => {
                setDate(date);
                setOpenFindDay(false);
              }}
              data={events}
            />
            <EventInfoModal
              open={eventInfoModal}
              handleClose={() => setEventInfoModal(false)}
              currentEvent={currentEvent as IEventInfo}
            />
            <AddTodoModal
              open={openTodoModal}
              handleClose={() => setOpenTodoModal(false)}
              todos={todos}
              setTodos={setTodos}
            />
            <Calendar
              localizer={localizer}
              events={events as any}
              onSelectEvent={handleSelectEvent}
              onSelectSlot={handleSelectSlot}
              selectable
              startAccessor="start"
              components={{ event: EventInfo }}
              endAccessor="end"
              defaultView="month"
              view="month"
              views={["month", "week"]}
              date={date ? date : new Date()}
              onNavigate={onNavigate}
              eventPropGetter={(event) => {
                const hasTodo = todos.find((todo) => todo._id === event._id);
                return {
                  style: {
                    // backgroundColor: hasTodo ? hasTodo.color : "#b64fc8",
                    borderColor: "#b64fc8",
                  },
                };
              }}
              style={{
                height: 900,
                padding: 0,
              }}
            />
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default EventCalendar;
